var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgType(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.857 14L21 26h-3.175l-.807-2.71h-4.09L12.103 26H9l4.161-12h3.696zm9.071 3c1.293 0 2.276.277 2.95.83.674.555 1.012 1.385 1.012 2.493v3.15c0 .45.198.675.596.675.21 0 .381-.023.514-.07l-.215 1.645c-.32.185-.697.277-1.128.277-1.193 0-1.906-.444-2.138-1.333-.497.889-1.48 1.333-2.95 1.333-.829 0-1.464-.185-1.906-.554-.442-.37-.663-.906-.663-1.61 0-.738.251-1.335.754-1.79.503-.457 1.329-.806 2.478-1.048l1.873-.38v-.312c0-.393-.105-.704-.315-.935-.21-.23-.497-.346-.862-.346-.42 0-.762.104-1.027.312-.266.207-.437.548-.514 1.02l-2.288-.692c.144-.842.542-1.497 1.194-1.964.652-.467 1.53-.701 2.635-.701zm1.177 5.123l-1.343.329c-.353.092-.605.205-.754.337-.149.133-.223.32-.223.563 0 .242.071.427.215.554.144.127.343.19.597.19.386 0 .734-.112 1.044-.337.27-.197.423-.45.457-.757l.007-.135v-.744zM14.991 16.4h-.036l-.484 1.873-.897 2.89h2.798l-.86-2.872-.521-1.891z",
    fill: "#222",
    fillRule: "nonzero"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgType);
export default __webpack_public_path__ + "static/media/Type.01d62ba5.svg";
export { ForwardRef as ReactComponent };